import EtablissementBrancheNom from '@/generated/controls/etablissement/EtablissementBrancheNom.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: EtablissementBrancheNom
})
